function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 40.0001C4 20.1177 20.1177 4 40.0001 4C59.8823 4 76 20.1177 76 40.0001C76 59.8823 59.8823 76 40.0001 76C20.1177 76 4 59.8823 4 40.0001ZM10.7253 36.7264H23.7993C24.533 27.6838 27.5593 19.0038 32.5549 11.4945C20.9154 14.5261 12.0775 24.4981 10.7253 36.7264ZM32.5564 68.506C20.9156 65.4747 12.0766 55.5015 10.7251 43.2719H23.7993C24.533 52.3153 27.5599 60.9962 32.5564 68.506ZM30.3693 43.2719C31.1914 52.1513 34.5346 60.611 39.999 67.6511C45.4634 60.611 48.8067 52.1513 49.6288 43.2719H30.3693ZM39.999 12.3472C45.4634 19.3873 48.8066 27.8469 49.6288 36.7264H30.3693C31.1914 27.8469 34.5346 19.3873 39.999 12.3472ZM47.4427 11.4938C52.4385 19.0033 55.465 27.6835 56.1988 36.7264H69.2748C67.9225 24.4972 59.0834 14.5247 47.4427 11.4938ZM69.2749 43.2719C67.9233 55.5023 59.0832 65.4761 47.4413 68.5066C52.438 60.9967 55.4649 52.3156 56.1988 43.2719H69.2749Z"
});

function SvgIconGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobe);
export default __webpack_public_path__ + "static/media/IconGlobe.4828bb17.svg";
export { ForwardRef as ReactComponent };